/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Indlæser...',
	'dlg_close': 'Luk',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annullér',
	'dlg_back': 'Gå tilbage',

	// Slider
	'sliderRegionLabel': 'Skyderkontrol, brug højre og venstre pil til at flytte skyderhåndtagene',
	'sliderHandleLabel': 'Skyderhåndtag',
	'a11ySliderHandleLabel': 'Skyderhåndtag %{sliderValue}',
	'sliderInputLabel': 'værdi',

	// Side bar
	'sidebarAdd': 'Tilføj',
	'clearTextFilterValue': 'Ryd',
	'missingDataSetData': 'Data til dette datasæt er ikke tilgængelige. Opfrisk datasættet, eller kontakt administratoren for at få adgang til kilden.',

	// Toolbar
	'toolbarRegionLabel': 'Værktøjslinje',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Fontserie',
	'fontSizeSelect': 'Fontstørrelse',
	'bold': 'Fed',
	'italic': 'Kursiv',
	'underline': 'Understreget',
	'justifyLeft': 'Justér til venstre',
	'justifyCenter': 'Justér centreret',
	'justifyRight': 'Justér til højre',
	'insertOrderedList': 'Sorteret liste',
	'insertUnorderedList': 'Usorteret liste',
	'fontColorPicker': 'Farvevælger',
	'textWrap': 'Tekstomløb',
	'restore': 'Gendan standardværdier',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Antal resultater',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'Værdien kan være %{lower} - %{higher}',
	'topbottomSelectOption': 'Øverste eller nederste - indstilling',
	'topbottomOptionLabel': 'Vis',
	'searchByLabel': 'Efter',
	'searchNoMatches': 'Ingen forekomster fundet',
	'topbottomRankColumnLabel': 'Tilføj en prioriteringskolonne til tabellen',
	'topbottomNone': 'Ingen',
	'topCount': 'Øverste antal',
	'topPercent': 'Øverste  %',
	'bottomCount': 'Nederste antal',
	'bottomPercent': 'Nederste  %',
	'searchColumn': 'Søg efter en kolonne',
	'searchColumnAriaLabel': 'Søg efter en kolonne. Skriv navnet på den kolonne, du vil søge efter, og brug derefter pil ned til at finde kolonnen på listen.',
	'rankColumnLabel': 'Prioritet (%{columnLabel})',
	'topbottomClearLabel': 'Ryd',

	// Format
	'formatAuto': 'Automatisk',
	'formatConvertPercent': 'Konvertér decimal til procent',
	'formatAbbreviate': 'Forkort',
	'formatUseGrouping': 'Brug tusindtalsskilletegn',
	'dateStyle': 'Datotypografi',
	'dateTimeStyle': 'Dato-/klokkeslætstypografi',
	'formatMissingValueCharactersInfo': 'Tegn for manglende værdi angiver de tegn, der skal vises, når værdien mangler.',
	'currencySymbolLabel': 'Valutasymbol',
	'customSymbolPlaceholder': 'Tilføj et symbol',
	'customSymbolLabelInfo': 'Angiver et eller flere tegn, der skal bruges som et tilpasset symbol. Symbolet vil stå foran tallet og et vilkårligt tegn.',
	'numberLabel': 'Taletiket',
	'numberPositionLabel': 'Etiketplacering',
	'numberLabelInfo': 'Angiver en etiket til et formateret tal og placeres som præfiks eller suffiks afhængigt af etiketplaceringen.',
	'nullValueDefault': '<standard>',
	'nullValueContent': '(ingen værdi)',
	'default': 'Standard',
	'beginning': 'Begyndelse',
	'end': 'Slutning',

	// More data indicator
	'moreDataIndicator': 'Data blev afkortet ved %{threshold} elementer. Anvend et filter for at få vist færre.',

	// Expanded View / Focus mode
	'evCollapse': 'Skjul',
	'duplicate': 'Duplikér',
	'copyOf': 'Kopi af %{name}',
	'unableToDuplicateBoard': 'Kan ikke dublere "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Objekterne kan ikke indlæses.',

	// Custom widgets
	'customWidget': 'Tilpasset widget'
});
